import { deviceWidth } from "../../utils/constant";

class ShowHide {
    constructor(handler, closeHandler, deviceOnly = '', noanchor = false, backdrop = null) {
        this.handlers = document.querySelectorAll(handler);
        this.deviceOnly = deviceOnly;
        this.noanchor = noanchor;
        this.closeHandler = closeHandler;
        this.backdrop = backdrop;
        this.targetBackdrop = null;
        this.closeBtn = null;
        this.targetContainer = null;
        this.init();
    }

    init() {
        if (this.handlers.length > 0) {
            this.handlers.forEach(handler => {
                handler.addEventListener("click", this.openContainer.bind(this));
            });

            this.targetContainer = document.getElementById(this.handlers[0].getAttribute('data-ref'));

            if (this.targetContainer) {
                this.closeBtn = this.targetContainer.querySelector(this.closeHandler);
            }
        }

        if (this.closeBtn) {
            this.closeBtn.addEventListener("click", this.closeContainer.bind(this));
        }

        this.targetBackdrop = document.querySelector(this.backdrop);
        if (this.targetBackdrop) {
            this.targetBackdrop.addEventListener("click", this.closeBackdrop.bind(this));
        }

        document.addEventListener("keydown", this.handleKeyDown.bind(this));
    }

    openContainer(e) {
        if (this.deviceOnly == "mobile") {
            if (window.innerWidth < deviceWidth.mobile) {
                this.openContainerAction(e);
            }
        } else if (this.deviceOnly == 'ipad') {
            if (window.innerWidth < deviceWidth.ipadpro) {
                this.openContainerAction(e);
            }
        } else if (this.deviceOnly == 'desktop') {
            if (window.innerWidth > deviceWidth.desktop) {
                this.openContainerAction(e);
            }
        } else {
            this.openContainerAction(e);
        }
    }

    openContainerAction(current) {
        if (this.noanchor) {
            current.stopPropagation();
        }
        if (this.targetContainer) {
            this.targetContainer.classList.add('open');
        }
        if (this.targetBackdrop) {
            this.targetBackdrop.classList.add('open');
            this.handlers[0].closest("html").classList.add("overflow-hidden");
        }
    }

    closeContainer() {
        if (this.targetContainer) {
            this.targetContainer.classList.remove('open');
        }
        if (this.targetBackdrop) {
            this.targetBackdrop.classList.remove('open');
            this.handlers[0].closest("html").classList.remove("overflow-hidden");
        }
    }

    closeBackdrop() {
        if (this.targetBackdrop) {
            this.targetContainer.classList.remove('open');
            this.targetBackdrop.classList.remove('open');
            this.handlers[0].closest("html").classList.remove("overflow-hidden");
        }
    }

    handleKeyDown(e) {
        if (e.key === "Escape") {
            this.closeContainer();
        }
    }
}

export default ShowHide;
